import React from "react";
import { IconBell24 } from "@warp-ds/icons/react/bell-24";

export const BellIcon = () => (
  <div
    aria-hidden="true"
    className="w-48 h-48 rounded-full s-bg-primary-default flex items-center justify-center s-text-inverted"
  >
    <IconBell24 />
  </div>
);
